<script lang="ts">
  import { onMount } from "svelte";
  import { pop } from "svelte-spa-router";
  import { storage, translate } from "lib";
  import { CheckboxComponent, Svg } from "ui";
  import { Capacitor } from "@capacitor/core";

  let isYoutubeMuted = false;
  let useAlternativePlayer = false;

  const onMuteYoutube = async (): Promise<void> => {
    await storage.set("isYoutubeMuted", isYoutubeMuted);
  };

  const onToggleAlternativePlayer = async (): Promise<void> => {
    await storage.set("useAlternativePlayer", useAlternativePlayer);
  };

  onMount(async (): Promise<void> => {
    const isMutedLocal = await storage.get("isYoutubeMuted");
    const useAlternativePlayerLocal = await storage.get("useAlternativePlayer");

    if (isMutedLocal !== null) { isYoutubeMuted = isMutedLocal; }
    if (useAlternativePlayerLocal !== null) { useAlternativePlayer = useAlternativePlayerLocal; }
  });
</script>

<div class="p-4 flex flex-col gap-4 {Capacitor.getPlatform() === 'android' ? 'mt-16' : Capacitor.getPlatform() === 'ios' ? 'mt-20' : ''}">

  <div class="relative pb-4">
    <div class="absolute">
      <Svg name="left-arrow-button" size={24} on:click={pop}/>
    </div>
    <div class="text-center font-semibold">
      {translate("ADVANCED_SETTINGS")}
    </div>
  </div>

  <CheckboxComponent
    label={translate("MUTE_YOUTUBE_VIDEOS")}
    bind:value={isYoutubeMuted}
    on:change={onMuteYoutube}
  />

  <CheckboxComponent
    label={translate("USE_ALTERNATIVE_VIDEO_PLAYER")}
    bind:value={useAlternativePlayer}
    on:change={onToggleAlternativePlayer}
  />

</div>
